"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  root: {
    '& .MuiSlider-rail': {
      color: _theme.default.palette.border,
      height: '1px',
      opacity: 'unset'
    },
    '& .MuiSlider-thumb': {
      '&.MuiSlider-active, &.Mui-focusVisible, &:hover': {
        boxShadow: 'none'
      }
    },
    '&.Mui-disabled': {
      color: _theme.default.palette.grayScale.disabled,
      '& .MuiSlider-thumb.Mui-disabled': {
        width: '12px',
        height: '12px',
        marginTop: '-5px',
        marginLeft: '-6px'
      }
    }
  },
  thumb: {
    color: _theme.default.palette.primary.light
  }
});
var _default = exports.default = useStyles;